export const PRODUCT_IMAGE_PLACEHOLDER_URL = `/assets/images/placeholder.svg`;
